import { css } from 'styled-components';

export const brandSpecificNavBorderStyle = css`
  border-block-start-width: 1px;
  border-block-start-color: #fff;
`;
